module.exports = __webpack_public_path__ + "static/img/product-9.528eca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-9.png
// module id = VRp9
// module chunks = 0